import React from 'react'

import { SH3, Stack, XStack } from '@zet/design-system'
import { useLoyaltyPayoutMeta } from '@zet/feature-loyalty'
import { ScrollView } from 'react-native-gesture-handler'

import { handlePayoutTableIconAndTitle } from '../../utils'
import TableColumns from './tableColumns'

const PayoutTable = ({
  commission,
  categoryId,
  tier,
  tierData,
  partnerId,
  partnerCategoryId,
}: {
  tier: any
  tierData: any
  commission?: string
  categoryId?: number | string
  partnerId?: number | string
  partnerCategoryId?: number
}) => {
  const {
    loyaltyPayout,
    isPercentagePayout,
    basePayoutValue,
    handleExtraPayoutColumn,
    handleCoinsColumn,
  } = useLoyaltyPayoutMeta({
    partnerId,
    partnerCategoryId,
    isAllLevelPayout: true,
    payoutContent: commission,
    categoryId: categoryId,
  })
  return (
    <XStack>
      <Stack className="border-grays-40 border-y" style={{ width: '30%' }}>
        <XStack className="border-grays-40 items-center border-r py-2">
          <SH3 className="text-neutral-white100">{'RC'}</SH3>
        </XStack>
        {handlePayoutTableIconAndTitle(tier, tierData)?.map((item, index) => (
          <XStack
            className={`items-center px-3 py-2 ${item?.bgColor} ${item?.border}`}
            key={index}
          >
            {item?.icon}
            {item?.title}
          </XStack>
        ))}
      </Stack>
      <ScrollView
        showsHorizontalScrollIndicator={false}
        horizontal
        className="border-grays-40 border-y"
        contentContainerStyle={{
          flex:
            handleExtraPayoutColumn() &&
            Boolean(loyaltyPayout?.GENIUS) &&
            handleCoinsColumn()
              ? 0
              : 1,
          justifyContent: 'center',
        }}
      >
        <TableColumns
          isPercentagePayout={isPercentagePayout}
          handleCoinsColumn={handleCoinsColumn}
          handleExtraPayoutColumn={handleExtraPayoutColumn}
          tier={tier}
          basePayoutValue={basePayoutValue}
          categoryId={categoryId}
          loyaltyPayoutData={loyaltyPayout}
        />
      </ScrollView>
    </XStack>
  )
}

export { PayoutTable }
